






























































import { Component, Vue } from 'vue-property-decorator';
import { clientsModule, supplierModule } from '@/store';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';
import SupplierThing from './SupplierThing.vue';

@Component({
  name: 'supplier-things-page',
  components: {
    UserMenu,
    MainNavbar,
    SupplierThing,
  },
})
export default class SupplierThings extends Vue {
  get loading() {
    return supplierModule.loading;
  }

  get things() {
    return supplierModule.things;
  }

  get selectedThing() {
    return supplierModule.selectedThing;
  }

  get client() {
    return clientsModule.model;
  }

  created() {
    supplierModule.fetchThings();
  }

  select(id: number) {
    supplierModule.setSelected(id);
  }

  isSelected(id: number) {
    return supplierModule.selected === id;
  }
}
